import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { Search16 } from '@makyoapp/makyo-icon/icon'
import { MaterialIcon } from '@makyoapp/makyo-tw-ui'
import { Button, ButtonVariant } from '@makyoapp/makyo-ui'

import { EVENT_KEYS } from '@/shared/custom-event'
import { useGridV2Context } from '@/components/GridV2/contexts/GridV2Context'

/**
 * @todo handle db tables search
 */
export const LayoutSearchbox = memo(() => {
  const { t } = useTranslation()
  const { searchConfig } = useGridV2Context()

  const isActive = searchConfig.value.trim().length > 0 || searchConfig.columnTypes.length > 0

  const getActiveSearchLabel = () => {
    if (searchConfig.columnTypes.length > 0) {
      return `Column Types Filter: ${searchConfig.columnTypes.length} Selected`
    }
    return `Active Search: '${searchConfig.value}'`
  }

  return (
    <Button
      id='layout-searchbox'
      className='relative p-2'
      noPadding
      squared
      title={isActive ? getActiveSearchLabel() : t('Search')}
      onClick={() => {
        window.dispatchEvent(new CustomEvent(EVENT_KEYS.GRID_SEARCH_TOGGLE))
      }}
      variant={isActive ? ButtonVariant.Outlined : ButtonVariant.Ghost}
    >
      <Search16 />

      {isActive && <span className='absolute top-[-4px] right-[-4px] bg-red-500 text-white rounded-full size-2' />}
    </Button>
  )
})

LayoutSearchbox.displayName = 'LayoutSearchbox'
